export const CREATE_SESSION_URL = '/rest/sessions/v2';
export const DELETE_SESSION_URL = '/rest/sessions/v1';
export const GET_SESSION_URL = '/rest/sessions/v2';
